module.exports = __webpack_public_path__ + "img/ai-weapon2.add5702e.png";